import React from 'react';

import { SerializedStyles } from '@emotion/react';
import { useSearchBox } from 'react-instantsearch-hooks-web';

import Search from '../Search/Search';

interface ISearchBox {
  withClear: boolean;
  placeholder?: string;
  wrapperStyles?: SerializedStyles | ((props: any) => SerializedStyles);
}

const SearchBox = ({ withClear = false, placeholder, wrapperStyles }: ISearchBox) => {
  const { refine, query } = useSearchBox();

  const handleClear = () => {
    refine('');
  };

  return (
    <Search
      refine={refine}
      currentRefinement={query}
      withClear={withClear}
      handleClear={handleClear}
      withAutocomplete
      searchPlaceholder={placeholder}
      wrapperStyles={wrapperStyles}
    />
  );
};

export default SearchBox;
